<template>
  <div>
    <h6 v-if="!formEmail" class="text-primary cursor-pointer mb-3" @click="openSelectEmailModal(null)">
      Paramétrer un mail automatique
    </h6>
    <div v-else class="m-3">
      <h6 class="text-primary cursor-pointer text-center">Un email a déjà été associé</h6>
      <div class="d-flex justify-content-around">
        <h-b-action-rounded icon="bx bx-show" @click.native="visualizeEmail(formEmail)"></h-b-action-rounded>
        <h-b-action-rounded icon="bx bx-edit-alt" @click.native="openSelectEmailModal(formEmail)"></h-b-action-rounded>
        <h-b-action-rounded icon="bx bx bx-undo" @click.native="formEmail = null"></h-b-action-rounded>
      </div>
    </div>
    <h-pop-template-email
      ref="templateEmail"
      v-model="actualEmail"
      :limit-to-service="this.limitToService"
      :limit-to-category="this.limitToCategory"
      @add="addEmail"
    ></h-pop-template-email>
    <h-pop-email-visualizer ref="emailVisualizer" :email="actualEmailVisualize"></h-pop-email-visualizer>
  </div>
</template>

<script>
import { APIRequest } from '@/node-sdk'

export default {
  name: 'email-select',

  props: {
    value: String,
    limitToService: {
      type: String,
      default: '',
    },
    limitToCategory: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      formEmail: this.value,
      actualEmail: null,
      actualEmailVisualize: {},
    }
  },

  watch: {
    value: function () {
      this.formEmail = this.value
    },

    formEmail: function () {
      this.$emit('input', this.formEmail)
    },
  },

  methods: {
    addEmail() {
      this.formEmail = this.actualEmail
    },

    openSelectEmailModal(actualEmail) {
      if (actualEmail) {
        this.actualEmail = actualEmail
      } else {
        this.actualEmail = null
      }
      this.$refs.templateEmail.managePopupOpen()
    },

    async visualizeEmail(emailId) {
      let email = await APIRequest.get_by_id(process.env.VUE_APP_NOTIFICATIONS_API, 'emails/templates', emailId)
      this.actualEmailVisualize = {
        title: email.title,
        object: email.object,
        text: email.text,
      }
      this.$refs.emailVisualizer.managePopupOpen()
    },
  },
}
</script>

<style scoped></style>
